import { List, ListItem, ListItemButton, Stack, Typography } from '@healthinal/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useRef, useState } from 'react';
import { ContentSection } from '../../components/ContentSection.tsx';
import { MotionDivider } from '../../components/MotionDivider.tsx';
import { StickyContainer } from '../../components/StickyContainer.tsx';
import { ContactPersonTable } from './components/tables/contact-person-table/ContactPersonTable.tsx';
import { InstitutionAddressTable } from './components/tables/InstitutionAddressTable.tsx';
import { MedicationTable } from './components/tables/medication-table/MedicationTable.tsx';
import { PersonalDataTable } from './components/tables/PersonalDataTable.tsx';
import { ReferencePersonTable } from './components/tables/reference-person-table/ReferencePersonTable.tsx';

export const Route = createFileRoute('/masterdata/')({
  component: Masterdata,
  staticData: { title: 'Stammdaten' },
});

function Masterdata() {
  const sideNavSectionRef = useRef(null);
  const [selectedSection, setSelectedSection] = useState<
    'personenliste' | 'medication' | 'institutionen' | 'ansprechpersonen' | 'bezugspersonen'
  >('personenliste');

  return (
    <Stack direction={'row'} gap={3}>
      <ContentSection flex={1} ref={sideNavSectionRef}>
        <StickyContainer>
          <Typography level={'h4'} sx={{ py: 1 }}>
            Kategorien
          </Typography>
          <List sx={{ '--ListItem-radius': '8px', textDecoration: 'none' }}>
            <ListItem>
              <ListItemButton
                selected={selectedSection === 'personenliste'}
                onClick={() => setSelectedSection('personenliste')}>
                Personenliste
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
                selected={selectedSection === 'institutionen'}
                onClick={() => setSelectedSection('institutionen')}>
                Institutionen
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
                selected={selectedSection === 'ansprechpersonen'}
                onClick={() => setSelectedSection('ansprechpersonen')}>
                Ansprechpersonen
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
                selected={selectedSection === 'bezugspersonen'}
                onClick={() => setSelectedSection('bezugspersonen')}>
                Bezugspersonen
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
                selected={selectedSection === 'medication'}
                onClick={() => setSelectedSection('medication')}>
                Medikation
              </ListItemButton>
            </ListItem>
          </List>
          <MotionDivider contentSectionRef={sideNavSectionRef} />
        </StickyContainer>
      </ContentSection>

      <ContentSection flex={4}>
        <Stack gap={2}>
          <Typography level="h1">Stammdaten</Typography>

          {selectedSection === 'personenliste' && (
            <Stack direction={'row'} gap={2}>
              <PersonalDataTable />
            </Stack>
          )}

          {selectedSection === 'institutionen' && (
            <Stack direction={'row'} gap={2}>
              <InstitutionAddressTable />
            </Stack>
          )}

          {selectedSection === 'ansprechpersonen' && (
            <Stack direction={'row'} gap={2}>
              <ContactPersonTable />
            </Stack>
          )}

          {selectedSection === 'bezugspersonen' && (
            <Stack direction={'row'} gap={2}>
              <ReferencePersonTable />
            </Stack>
          )}

          {selectedSection === 'medication' && (
            <Stack direction={'row'} gap={2}>
              <MedicationTable />
            </Stack>
          )}
        </Stack>
      </ContentSection>
    </Stack>
  );
}
